module.exports = __webpack_public_path__ + "img/logo3.da056230.png";